module.exports = __webpack_public_path__ + "img/116.221b8b16.jpg";